import { createRouter, createWebHistory } from 'vue-router'

import loginViews from '@/views/login/index.vue'

const routes = [
  {
    path: '/',
    component: loginViews,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router